<template>
  <div>
    <div class="container pt-3">
      <div class="row">
        <div class="col-lg-12">
          <!-- User Interface controls -->
          <b-row class="pb-2  text-right">
            <b-col lg="8" class="mb-1 text-left"> </b-col>
            <b-col class="mb-1 text-left">
              <b-form-group
                label="Filter"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="sm"
                label-for="filterInput"
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    placeholder="Type to Search"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-table
                bordered
                hover
                :items="items"
                small
                :per-page="perPage"
                :current-page="currentPage"
                :fields="fields"
                :filter="filter"
                @filtered="onFiltered"
                thead-class="ranking-head text-center"
                stacked="sm"
                responsive="sm"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                sort-icon-left
              >
                <template #cell(evolution)="data">
                  <i :class="'fas fa-' + evolution(data.item)"></i>
                  (
                  {{ data.item['2020'] !== '-' ? data.item['2020'] - data.item['2021'] : '' }} )
                </template>
              </b-table>
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="left"
                size="sm"
                class="my-0"
              ></b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ranking from '@/assets/data/geurs2021.json';

export default {
  components: {},
  mounted() {
    //console.log('RANKING', ranking);
    this.totalRows = this.ranking.length;
  },
  data() {
    return {
      article: {},
      ranking: ranking,
      filter: '',
      perPage: 15,
      totalRows: 1,
      currentPage: 1,
      sortBy: '2021',
      sortDesc: false,
      fields: [
        {
          key: 'University',
          sortable: true
        },
        { key: 'Country', sortable: true },
        { key: '2020', sortable: true, class: 'text-center' },
        { key: '2021', sortable: true, class: 'text-center' },
        {
          key: 'evolution',
          class: 'text-center'
        }
      ]
    };
  },
  computed: {
    items() {
      return this.ranking;
    }
  },
  methods: {
    evolution(item) {
      let res;
      console.log('ITEM', item);
      if (item['2020'] == '-') res = '-';
      else if (item['2020'] == item['2021']) res = 'angle-right text-info';
      else if (parseInt(item['2020']) < parseInt(item['2021'])) res = 'angle-down text-danger';
      else res = 'angle-up text-success';
      return res;
      //return item['2019'] > item['2020'] ? 'sup' : 'inf';
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    }
  }
};
</script>

<style></style>
